import React from "react";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import AnimatedBackground from "./AnimatedBackground";
import TypeLine from "./TypeLine";

const HEADLINE = [
    { text: "hi, " },
    { text: "hansa", className: "text-accent" },
    { text: " here." },
];

const Intro = () => (
    <section
        id="intro"
        className="hero relative flex items-center overflow-hidden pt-14 md:pt-0"
    >
        <AnimatedBackground />

        <div className="shell relative z-10 py-16 sm:py-20">
            <p
                className="eyebrow mb-6 animate-rise"
                style={{ animationDelay: "0.1s" }}
            >
                Associate Software Engineer
            </p>

            <TypeLine
                segments={HEADLINE}
                className="text-display font-semibold text-ink"
            />

            <p
                className="mt-4 max-w-prose text-lede font-light text-ink-dim animate-rise sm:mt-6"
                style={{ animationDelay: "0.9s" }}
            >
                I love crafting solutions.
            </p>

            <p
                className="mt-5 max-w-prose text-[16px] leading-relaxed text-ink-faint animate-rise sm:mt-6 sm:text-[17px]"
                style={{ animationDelay: "1.05s" }}
            >
                A curious creator who thrives on continuous learning and turns
                new knowledge into meaningful innovation. I don't just follow
                trends — I study them, understand them, and use that insight to
                build work that lasts.
            </p>

            <div
                className="mt-8 flex flex-wrap items-center gap-3 animate-rise sm:mt-10"
                style={{ animationDelay: "1.2s" }}
            >
                <a
                    href="mailto:hansagayashan7@gmail.com"
                    className="btn btn-accent"
                >
                    <EmailRoundedIcon style={{ fontSize: 17 }} />
                    Say hi
                </a>
                <a href="#projects" className="btn">
                    View work
                </a>
            </div>
        </div>

        <a
            href="#about"
            aria-label="Scroll to about"
            className="absolute bottom-10 left-1/2 hidden -translate-x-1/2 text-ink-faint
                       transition-colors duration-300 hover:text-accent md:block"
        >
            <ArrowDownwardRoundedIcon style={{ fontSize: 22 }} />
        </a>
    </section>
);

export default Intro;
